import { Button, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { TipologiaImmagine } from "../../types"
import { useNavigate, useParams } from "react-router-dom"
import { Formik } from "formik"
import { initialValuesTipologiaImmagine, validationSchemaTipologiaImmagine } from "./TipologiaImmagineCommon"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import ModalDelete from "../../components/ModalDelete"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import {
  useTipologiaImmagine,
  useTipologiaImmagineDelete,
  useTipologiaImmagineUpdate,
} from "../../hooks/tipologie-immagini"
import TipologiaImmagineForm from "./TipologiaImmagineForm"
import { transformErrorForForm } from "../../utils/utils"

export default function TipologiaImmagineUpdate() {
  const updateTipologiaImmagine = useTipologiaImmagineUpdate()
  const navigate = useNavigate()

  const { id } = useParams()

  const { data: tipologiaImmagine } = useTipologiaImmagine(Number(id))

  const [modalStateDeleteTipologiaImmagine, modalActionsDeleteTipologiaImmagine] = useModalTrigger()

  const deleteTipologiaImmagine = useTipologiaImmagineDelete()

  const initialValues = useMemo(() => initialValuesTipologiaImmagine(tipologiaImmagine), [tipologiaImmagine])
  const validationSchema = useMemo(() => validationSchemaTipologiaImmagine(), [])

  useBreadcrumbs([
    { label: "Tipologie Immagini", href: "/edizioni/tipologie-immagini" },
    { label: "Dettaglio Tipologia Immagine" },
  ])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1>{tipologiaImmagine?.nome}</H1>
          <Button
            size="md"
            variant="danger"
            title="Elimina"
            leadingIcon="delete"
            onClick={() => {
              modalActionsDeleteTipologiaImmagine.open()
            }}
          />
        </Flex>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return updateTipologiaImmagine.mutateAsync(values as TipologiaImmagine).then(() => {
                navigate(`/tipologie-immagini/tipologie-immagini`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6">
                  <TipologiaImmagineForm />
                </Container>
                <BottomFormFixed url="/tipologie-immagini/tipologie-immagini" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
      <ModalDelete
        isOpen={modalStateDeleteTipologiaImmagine.isOpen}
        onClose={modalActionsDeleteTipologiaImmagine.close}
        onDelete={() => {
          return deleteTipologiaImmagine.mutateAsync(tipologiaImmagine?.id).then(() => {
            navigate(`/tipologie-immagini/tipologie-immagini`)
          })
        }}
        message="Sei sicuro di voler eliminare la tipologia immagine?"
        title="Elimina Tipologia Immagine"
      />
    </Layout>
  )
}
